<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <BTableCommon
      v-model="selected"
      type="permission-info-models"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
    />
  </BLayoutList>
</template>

<script>
import { authPermissionPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { PermissionsInfoModelModel as Model } from './Model'
import { permissionsInfoModelsStoreModule as StoreModule } from './store'
import {
  PERMISSIONS_INFOMODELS_ROUTES as ROUTES,
} from './utils'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewPermissionsInfoModelsList',
  components: {
    BLayoutList,
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
}
</script>
